import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    links = "links",
    numberOfTabs = "numberOfTabs",
}
interface LinkModel {
    fields: {
        title: string;
        description: string;
        logoImage: string;
        imgAltText: string;
        children?: LinkModel[];
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
    };
}

type Props = OwnProps;

export interface HerbsSpecificationStyles {
    container?: GridContainerProps;
    mainGridContainer: GridItemProps;
    categoryImageItem?: GridItemProps;
    categoryImage?: LazyImageProps;
    textGridItem?: GridItemProps;
    titleGridItem?: GridItemProps;
    titleLabel?: TypographyPresentationProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyPresentationProps;
}
export const herbsSpecificationStyles: HerbsSpecificationStyles = {
    container: {
        css: css`
            width: 100%;
            padding: 2rem 4rem;
            margin: 0 auto;
            background: #fff;
            > ${GridOffset} {
                width: 100%;
                padding: 0;
                margin: 0 auto;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0;
                        padding-right: 0;
                    `,
                    css`
                        padding-left: 0;
                        padding-right: 0;
                    `,
                    css`
                        padding-left: 1rem;
                        padding-right: 1rem;
                    `,
                    css`
                        padding: 2rem 0;
                        > ${GridOffset} {
                            flex-wrap: nowrap;
                        }
                    `,
                    css`
                        > ${GridOffset} {
                            flex-wrap: nowrap;
                        }
                    `,
                ])}
        `,
    },
    mainGridContainer: {
        width: [12, 6, 6, 4, 3],
        css: css`
            padding: 0;
            // display: flex;
            display: block;
            align-items: center;
            margin: 1rem 0px !important;
            > ${GridOffset} {
                width: 100%;
                padding: 0;
                margin: 0 auto;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 50%;
                        max-width: 50%;
                        margin: 1rem 0px 2rem !important;
                    `,
                    css`
                        flex-basis: 50%;
                        max-width: 50%;
                        margin: 1rem 0px 2rem !important;
                    `,
                    css`
                        margin: 1rem 0px 2rem !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },

    categoryImageItem: {
        width: 4,
        css: css`
            padding: 0px;
            justify-content: center;
            align-items: center;
            margin: 0 auto !important;
        `,
    },
    categoryImage: {
        width: "80px",
        height: "80px",
        css: css`
            border-radius: 50%;
            margin: 0 auto;
            opacity: 1;
            z-index: 98;
            background: #f0f4f3;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 70px;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}

            img {
                height: 100%;
            }
        `,
    },
    textGridItem: {
        width: 8,
        css: css`
            flex-direction: column;
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px;
        `,
    },
    titleGridItem: {
        width: 12,
        css: css`
            padding: 17px 0 0 !important;
            margin: 0 auto !important;
            color: ${getColor("primary")};

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 15px 0 0 !important;
                        size: 18;
                    `,
                    css`
                        padding: 15px 0 0 !important;
                        size: 18;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    titleLabel: {
        size: 22,
        css: css`
            font-family: sabon-next-lt-pro;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        size: 18;
                    `,
                    css`
                        size: 18;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding: 15px 13px 0 13px;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 15px 15px 0 15px;
                    `,
                    css`
                        padding: 15px 15px 0 15px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    descriptionText: {
        size: 16,
        css: css`
            padding: 0px;
            color: #333333;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        size: 12;
                    `,
                    css`
                        size: 12;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const styles = herbsSpecificationStyles;
export const HerbsSpecification = ({ fields }: Props) => {
    return (
        <>
            <StyledWrapper>
                <GridContainer {...styles.container}>
                    {fields.links.map(destinationLink => (
                        <>
                            <GridItem {...styles.mainGridContainer}>
                                {destinationLink.fields.logoImage && (
                                    <GridItem {...styles.categoryImageItem}>
                                        <LazyImage
                                            src={destinationLink.fields.logoImage}
                                            className="category-image"
                                            altText={destinationLink.fields.imgAltText}
                                            {...styles.categoryImage}
                                        />
                                    </GridItem>
                                )}
                                <GridItem {...styles.textGridItem}>
                                    {destinationLink.fields.title && (
                                        <GridItem {...styles.titleGridItem}>
                                            <Typography {...styles.titleLabel}>
                                                {destinationLink.fields.title}
                                            </Typography>
                                        </GridItem>
                                    )}
                                    {destinationLink.fields.description && (
                                        <GridItem {...styles.descriptionGridItem}>
                                            <Typography {...styles.descriptionText}>
                                                {destinationLink.fields.description}
                                            </Typography>
                                        </GridItem>
                                    )}
                                </GridItem>
                            </GridItem>
                        </>
                    ))}
                </GridContainer>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: HerbsSpecification,
    definition: {
        group: "Basic",
        displayName: "Herbs Specification",
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "description",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "logoImage",
                        displayName: "Logo Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "imgAltText",
                        displayName: "Image altText",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
